import state from './moduleCouponsState'
import mutations from './moduleCouponsMutations'
import actions from './moduleCouponsActions'
import getters from './moduleCouponsGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
